import axios from "@/axios";

const formatter = new Intl.DateTimeFormat("fr-CA",
 { year: 'numeric', month: '2-digit', day: '2-digit' }
);

const formatterd = new Intl.DateTimeFormat("fr-CA", {
  year: "numeric",
  month: "2-digit",
  day: "2-digit"
});


export default {
  fetchDisciplinas(currentWeek,lang,signal) {
    const datai = formatter.format(currentWeek.start);
    const dataf = formatter.format(currentWeek.end);
    lang = lang == null ? "pt" : lang;
    return axios.get(`/calendario/options/ucs?idioma=${lang}&di=${datai}&df=${dataf}`,
    {signal: signal})
      .then(data => {
        return data.data.map(el => ({
          ...el,
          label: el.label,
          value: el.valor
        })).sort((a, b) => a.label.localeCompare(b.label));
      })
      .catch(error => {
        if (error.name === "CanceledError") {
          console.log('Request was aborted');
          return [];
        } else {
          console.log(error);
          throw error; // rethrow so that the calling code can handle the error too
        }
      });
  },
  fetchTurmas(currentWeek,lang,signal) {
    const datai = formatter.format(currentWeek.start);
    const dataf = formatter.format(currentWeek.end);
    return axios.get(`/calendario/options/turmas?idioma=${lang}&di=${datai}&df=${dataf}`,
    {signal: signal})
    .then(data => {
      return data.data.map(el => {
        const label = this.ano != null ?
          `${el.label}` : `${el.label} - ${el.ano}ºAno`
        return {
          ...el,
          label: label,
          value: el.valor
        }
      });
    }).catch(error => {
      if (error.name === "CanceledError") {
        console.log('Request was aborted');
        return [];
      } else {
        console.log(error);
        throw error; // rethrow so that the calling code can handle the error too
      }
    })
  },
  fetchCiclos(currentweek,lang,signal) {
    const datai = formatter.format(currentweek.start);
    const dataf = formatter.format(currentweek.end);
    const parameters = `&di=${datai}&df=${dataf}`;
    lang = lang == null ? "pt" : lang;
    return axios.get(`/calendario/options/ciclos?idioma=${lang}${parameters}`,{signal: signal}).then(data => {
      return data.data.map(el => {
        return {
          ...el,
          label: el.label,
          value: el.valor
        }
      });
    }).catch(error => {
      if (error.name === "CanceledError") {
        console.log('Request was aborted');
        return [];
      } else {
        console.log(error);
        throw error; // rethrow so that the calling code can handle the error too
      }
    })
  },
  fetchCursos(currentweek,lang,signal) {
    const datai = formatter.format(currentweek.start);
    const dataf = formatter.format(currentweek.end);
    return axios.get(`/calendario/options/cursos?idioma=${lang}&di=${datai}&df=${dataf}`,{signal: signal})
    .then(data => {
      return data.data.map(el => {
        return {
          ...el,
          label: el.label,
          value: el.valor
        }
      });
    }).catch(error => {
      if (error.name === "CanceledError") {
        console.log('Request was aborted');
        return [];
      } else {
        console.log(error);
        throw error; // rethrow so that the calling code can handle the error too
      }
    })
  },
  fetchDocentes(currentweek,signal){
    const datai = formatter.format(currentweek.start);
    const dataf = formatter.format(currentweek.end);
    return axios.get(`/calendario/options/docentes?di=${datai}&df=${dataf}`,
    {signal: signal}).then(data => {
      return data.data.map(el => {
          return {
            ...el,
            label: el.label,
            value: el.valor
          }
        }).sort((a,b) =>{
          if( a.label < b.label) {
            return -1;
          }
          return 1;
        });
      }).catch(error => {
        if (error.name === "CanceledError") {
          console.log('Request was aborted');
          return [];
        } else {
          console.log(error);
          throw error; // rethrow so that the calling code can handle the error too
        }
      })
  },
  fetchSalas(currentweek,lang,signal) {
    const datai = formatter.format(currentweek.start);
    const dataf = formatter.format(currentweek.end);
    const parameters = `&di=${datai}&df=${dataf}`;

    const language = lang != "pt" && lang != "en" ? "pt" : lang;

    return axios.get(`/calendario/options/salas?idioma=${language}${parameters}`,
    {signal: signal}).
      then(data => {
        return data.data.map(el => {
          return {
            ...el,
            label: el.Edificio + " - " + el.Label,
            value: el.IdSala
          }
        });
      }).catch(error => {
        if (error.name === "CanceledError") {
          console.log('Request was aborted');
          return [];
        } else {
          console.log(error);
          throw error; // rethrow so that the calling code can handle the error too
        }
      })
  },
  fetchAvaliacao(currentweek,lang,signal){
    const datai = formatter.format(currentweek.start);
    const dataf = formatter.format(currentweek.end);
    const url = `/calendario/options/avaliacao?idioma=${lang}&di=${datai}&df=${dataf}`;
    return axios.get(url,{signal: signal}).then(data => {
      return data.data.map(el => {
        return {
          ...el,
          value: el.valor
        }
      });
    }).catch(error => {
      if (error.name === "CanceledError") {
        console.log('Request was aborted');
        return [];
      } else {
        console.log(error);
        throw error; // rethrow so that the calling code can handle the error too
      }
    })
  },
  fetchDisciplinasWithAvaliacao(currentWeek,lang,signal) {
    const datai = formatter.format(currentWeek.start);
    const dataf = formatter.format(currentWeek.end);
    return axios.get(`/calendario/options/ucsavaliacao?idioma=${lang}&di=${datai}&df=${dataf}`,
    {signal: signal})
      .then(data => {
        return data.data.map(el => ({
          ...el,
          label: el.label,
          value: el.valor
        })).sort((a, b) => a.label.localeCompare(b.label));
      })
      .catch(error => {
        if (error.name === "CanceledError") {
          console.log('Request was aborted');
          return [];
        } else {
          console.log(error);
          throw error; // rethrow so that the calling code can handle the error too
        }
      });
  },
  fetchCalendarios(selectedWeek, searchParams, lang){
    const parameters = buildQueryStringForSearch(selectedWeek,searchParams);
    const url = `/calendario/events${parameters}&lang=${lang}`;
    return axios.get(url)
      .then(data => data)
      .catch(error => {
        console.log(error);
        throw error; // rethrow so that the calling code can handle the error too
      })
  },
  fetchCalendariosWithSignal(selectedWeek, searchParams, lang,signal){
    const parameters = buildQueryStringForSearch(selectedWeek, searchParams);
    const url = `/calendario/events${parameters}&lang=${lang}`;
    return axios.get(url, {
      signal: signal  // Attach the AbortController's signal to the request
    })
    .then(data => data)
    .catch(error => {
      if (error.name === "CanceledError") {
        console.log('Request was aborted');
      } else {
        console.log(error);
        throw error; // rethrow so that the calling code can handle the error too
      }
    });  
  },
  
}

const buildQueryStringForSearch = (selectedWeek, searchParams) => {
  const start = formatterd.format(selectedWeek.start);
  const end = formatterd.format(selectedWeek.end);

  const { cursoid, ano, disciplina, turma, sala, docente, avaliacao, selectedOption } = searchParams;

  let querystring = `?di=${start}&df=${end}`;
  if(cursoid != null){
    querystring += `&cursoid=${cursoid}&ano=${ano.value}`;
  }
  if(disciplina != null){
    querystring += `&idcadeira=${disciplina.value}`;
  }
  if(turma != null){
    querystring += `&idcursoturma=${turma.valor}`;
  }
  if(sala != null){
    querystring += `&idsala=${sala.IdSala}`;
  }
  if(docente != null){
    querystring += `&iddocente=${docente.value}`;
  }
  if(avaliacao != null){
    querystring += `&idaval=${avaliacao.valor}`;
  }
  if(selectedOption.id == 3){
    querystring += `&isavaliacao=true`;
  }
  return querystring;
}
